<template>
  <!-- ページ内容 -->
  <div class="l-page l-page--onboarding">
    <main class="l-main">
      <div class="l-main-head">
        <div class="p-onboarding-progress">
          <div class="p-onboarding-progress__title">
            <div class="c-text">STEP.2</div>
          </div>
          <div class="p-onboarding-progress__content">
            <h1 class="c-title">
              <div class="c-title__text u-fs40">Webサイトでの設定</div>
            </h1>
            <div class="c-progress">
              <ul class="c-progress-list">
                <li class="c-progress-list__item">導入準備</li>
                <li class="c-progress-list__item is-current">プロジェクト作成</li>
                <!-- <li class="c-progress-list__item">テスト配信</li> -->
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="l-main-content">
        <div class="p-onboarding__outline">
          <div class="c-text">
            Webサイトでタグの設置とファイルのアップロードを行うことで、サイトへアクセスしたユーザーへオプトイン（通知許可）ダイアログの表示が開始されます。
          </div>
        </div>
        <div class="p-onboarding-tag">
          <h2 class="c-title">
            <div class="c-title__text u-fs34">プロジェクトの登録が完了しました！</div>
          </h2>
          <div class="p-onboarding-tag__outline">
            <h3 class="c-title">
              <div class="c-title__text u-fs24">配信するサイトにタグを設置・モジュールファイルを導入しましょう。</div>
            </h3>
            <div class="c-text">
              スクリプトタグを設置し、ブラウザモジュールファイル（serviceworker.js）をWebサイトのルートディレクトリへ保存することで、タグが設置されたページでプッシュ通知のオプトイン（許可取得）が開始されます。
            </div>
          </div>
          <ul class="p-onboarding-tag-list">
            <li class="p-onboarding-tag-list__item">
              <h4 class="p-onboarding-tag__title" data-number="1">ブラウザモジュールのアップロード</h4>
              <div class="c-text">
                ブラウザモジュールファイル（serviceworker.js）をダウンロードして、通知許可を取得するドメインのルートディレクトリへアップロードします。
              </div>
              <div class="p-onboarding-tag__btns">
                <a class="c-btn c-btn--gray u-w280" href="#serviceworker.js" @click="onServiceWorkerClick($event)">
                  <div class="c-icon c-icon--white u-wh24 c-icon--alpha50">
                    <svg
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                    >
                      <use xlink:href="/assets/img/sprite.svg#download" />
                    </svg>
                  </div>
                  <p class="c-btn__text">serviceworker.js</p>
                </a>
                <!-- <a class="c-btn c-btn--gray u-w228" href="#manifest.json" v-on:click="onManifestClick($event)">
                                <div class="c-icon c-icon--white u-wh24 c-icon--alpha50">
                                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg"
                                        xmlns:xlink="http://www.w3.org/1999/xlink">
                                        <use xlink:href="/assets/img/sprite.svg#download">
                                        </use>
                                    </svg>
                                </div>
                                <p class="c-btn__text">manifest.json</p>
                            </a> -->
              </div>
              <ul class="p-onboarding-tag-suppl-list">
                <!-- <li class="p-onboarding-tag-suppl-list__item">※manifest.jsonはserviceworker.jsと同じディレクトリに配置して下さい。</li> -->
                <li class="p-onboarding-tag-suppl-list__item">
                  ※ルートディレクトリに設置が出来ない場合はタグの記載を変更する必要があります。くわしくは<a style="text-decoration: underline;" href="https://manual.webpush.jp/posts/initialsetting-serviceworker" target="_blank">こちら</a>
                </li>
              </ul>
            </li>
            <li class="p-onboarding-tag-list__item">
              <h4 class="p-onboarding-tag__title" data-number="2">スクリプトタグの設置</h4>
              <div class="c-text">
                訪問者へプッシュ通知を配信するには、ユーザーが通知許可（オプトイン）する必要があります。<br />
                こちらのタグを設置したページにて通知許可ダイアログを表示しユーザーがオプトインを行えます。
              </div>
              <ul class="p-onboarding-tag-setting-list">
                <li class="p-onboarding-tag-setting-list__item">
                  <div class="c-input">
                    <div class="c-input__title u-w200">プレオプトイン対応</div>
                    <div class="c-radio u-w680">
                      <ul class="c-radio-list">
                        <li class="c-radio-list__item" style="margin-bottom: 0;">
                          <label class="c-radio__label">
                            <input
                              v-model="isPreoptinChecked"
                              type="radio"
                              name="isPreoptinChecked"
                              :value="0"
                              @change="onScriptTagSettingChange"
                            />
                            <div class="c-radio__item">
                              <div class="c-radio__box"></div>
                              <div class="c-radio__box-label">なし</div>
                            </div>
                          </label>
                        </li>
                        <li class="c-radio-list__item" style="margin-bottom: 0;">
                          <label class="c-radio__label">
                            <input
                              v-model="isPreoptinChecked"
                              type="radio"
                              name="isPreoptinChecked"
                              :value="1"
                              @change="onScriptTagSettingChange"
                            />
                            <div class="c-radio__item">
                              <div class="c-radio__box"></div>
                              <div class="c-radio__box-label">全てのブラウザ</div>
                            </div>
                          </label>
                        </li>
                        <li class="c-radio-list__item" style="margin-top: 0; margin-bottom: 0;">
                          <label class="c-radio__label">
                            <input
                              v-model="isPreoptinChecked"
                              type="radio"
                              name="isPreoptinChecked"
                              :value="2"
                              @change="onScriptTagSettingChange"
                            />
                            <div class="c-radio__item">
                              <div class="c-radio__box"></div>
                              <div class="c-radio__box-label">必須ブラウザのみ</div>
                            </div>
                          </label>
                          <div
                            v-tooltip="'Firefox、Edge、Safariなど、通知許可にプレオプトインが必須なブラウザにのみ表示します。'"
                            style="
                                                        height: 16px;
                                                        margin-top: 3px;
                                                        margin-left: 2px;
                                                        width: 16px;
                                                    "
                          >
                            <svg
                              version="1.1"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                              style="height: 16px;"
                            >
                              <use xlink:href="/assets/img/sprite.svg#question" style="fill: #999; cursor: pointer;" />
                            </svg>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="c-input__text c-input__text--spec c-text">
                    <p>※「プレオプトイン対応」のマニュアルは<a style="text-decoration: underline;" target="_blank" href="https://manual.webpush.jp/posts/feature-optindialog">こちら</a></p>
                  </div>
                </li>
                <li class="p-onboarding-tag-setting-list__item">
                  <div class="c-input">
                    <div class="c-input__title u-w200">iOS対応</div>
                    <div class="c-radio u-w680">
                      <ul class="c-radio-list">
                        <li class="c-radio-list__item" style="margin-bottom: 0;">
                          <label class="c-radio__label">
                            <input
                              v-model="isIosChecked"
                              type="radio"
                              name="isIosChecked"
                              :value="false"
                              @change="onScriptTagSettingChange"
                            />
                            <div class="c-radio__item">
                              <div class="c-radio__box"></div>
                              <div class="c-radio__box-label">なし</div>
                            </div>
                          </label>
                        </li>
                        <li class="c-radio-list__item" style="margin-top: 0; margin-bottom: 0">
                          <label class="c-radio__label">
                            <input
                              v-model="isIosChecked"
                              type="radio"
                              name="isIosChecked"
                              :value="true"
                              @change="onScriptTagSettingChange"
                            />
                            <div class="c-radio__item">
                              <div class="c-radio__box"></div>
                              <div class="c-radio__box-label">あり</div>
                            </div>
                          </label>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="c-input__text c-input__text--spec c-text">
                    <p>※「iOS対応」のマニュアルは<a style="text-decoration: underline;" target="_blank" href="https://manual.webpush.jp/posts/feature-ios">こちら</a></p>
                    <p>&nbsp;&nbsp;&nbsp;&nbsp;また、iOS対応するにはPWA設定も必要です。プロジェクト作成後にサイドメニュー「PWA設定」よりお進みください。</p>
                  </div>
                </li>
                <li class="p-onboarding-tag-setting-list__item">
                  <div class="c-input">
                    <div class="c-input__title u-w200">ブロック解除バー対応</div>
                    <div class="c-radio u-w680">
                      <ul class="c-radio-list">
                        <li class="c-radio-list__item" style="margin-bottom: 0;">
                          <label class="c-radio__label">
                            <input
                              v-model="isBlockChecked"
                              type="radio"
                              name="isBlockChecked"
                              :value="false"
                              @change="onScriptTagSettingChange"
                            />
                            <div class="c-radio__item">
                              <div class="c-radio__box"></div>
                              <div class="c-radio__box-label">なし</div>
                            </div>
                          </label>
                        </li>
                        <li class="c-radio-list__item" style="margin-top: 0; margin-bottom: 0">
                          <label class="c-radio__label">
                            <input
                              v-model="isBlockChecked"
                              type="radio"
                              name="isBlockChecked"
                              :value="true"
                              @change="onScriptTagSettingChange"
                            />
                            <div class="c-radio__item">
                              <div class="c-radio__box"></div>
                              <div class="c-radio__box-label">あり</div>
                            </div>
                          </label>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="c-input__text c-input__text--spec c-text">
                    <p>※「ブロック解除バー対応」のマニュアルは<a style="text-decoration: underline;" target="_blank" href="https://manual.webpush.jp/posts/feature-unblockingrequest">こちら</a></p>
                  </div>
                </li>
              </ul>
              <div class="c-textarea">
                <textarea
                  v-model="scriptTag"
                  class="c-textarea__item u-w842 u-h112"
                  name="script_tag"
                  readonly
                ></textarea>
                <div class="c-textarea__text c-textarea__text--spec c-text">
                  <p>※ブラウザプッシュタグは各種タグマネージャーで設置可能ですので、お使いのタグマネージャー</p>
                  <p>（GoogleTagManagerなど）でも設置可能です。詳しい導入方法は<a style="text-decoration: underline;" href="https://manual.webpush.jp/posts/initialsetting-tag-gtm" target="_blank">こちら</a></p>
                </div>
                <button
                  class="c-btn c-btn--circle"
                  type="button"
                  name="clip"
                  value="add-user"
                  @click="onClipClick($event)"
                >
                  <div
                    v-tooltip="{
                      content: isCopied
                        ? 'コピーしました'
                        : 'クリップボードにコピー',
                      hideTriggers: (triggers) => triggers.filter((trigger) => trigger !== 'click'),
                    }"
                    @click="toggleCopyText"
                  >
                    <div class="c-icon-circle c-icon-circle--gray-2 u-wh40">
                      <div
                        class="c-icon-circle__item c-icon-circle__item--white c-icon__item--alpha70 u-wh20"
                      >
                        <svg
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                        >
                          <use xlink:href="/assets/img/sprite.svg#clipboard" />
                        </svg>
                      </div>
                    </div>
                  </div>
                </button>
                <div v-show="isIosChecked || isPreoptinChecked || isBlockChecked">
                  <div class="c-textarea__text c-textarea__text--spe c-textarea__text_small_margin ">
                    <p>※各種チェックボックスを選択した場合、プレオプトイン・ブロック解除バーはデフォルトデザインが適応されています。</p>
                    <p class="p-pre-optin-message">以下のオプションタグを設定することにより、より良いデザインに変更が可能となります。</p>
                    <p class="p-pre-optin-message">オプションタグはブラウザプッシュタグの直後に設置をお願いいたします。</p>
                  </div>
                  <!-- プレオプトイン・ブロック解除バーオプション -->
                  <DialogOptionTabs
                    :copy-id="'dialogOptionTag'"
                    :class-name="'p-project-edit-for-onbording'"
                    :project-icon-url="iconUrl"
                  />
                </div>
              </div>
            </li>
            <li class="p-onboarding-tag-list__item">
              <h4 class="p-onboarding-tag__title" data-number="3">ダイアログの表示確認</h4>
              <div class="c-text">
                ブラウザプッシュタグを設置したページへアクセスすると、通知許可を求めるダイアログが表示されることを確認しましょう。表示されるダイアログに従って「通知の表示の許可」を行ってください。
              </div>
              <div class="c-image"><img src="/assets/img/capture-onboarding-firebase-09.png" /></div>
            </li>
          </ul>
          <div class="p-onboarding-btns">
            <button
              class="c-btn c-btn--modal c-btn--blue u-w320 u-h50 u-fs--xl"
              type="button"
              name="edit"
              value="edit"
              @click="onNextClick($event)"
            >
              <p class="c-btn__text">メイン画面へ進む</p>
            </button>
          </div>
        </div>
      </div>
    </main>
  </div>
<!-- /ページ内容 -->
</template>

<script>
import axios from "axios";
export default {
  props: {
    nextUrl: String,
    previousUrl: String,
    faqUrl: String,
    tag: String,
    iconUrl: String,
  },
  data() {
    return {
      scriptTag: this.tag,
      isIosChecked: false,
      isPreoptinChecked: 0,
      isBlockChecked: false,
      isCopied: false,
    }
  },
  methods: {
    onFaqClick: function (_event) {
      alert('TODO FAQ URL');
      //location.href = this.faqUrl;
    },
    onNextClick: function (_event) {
      location.href = this.nextUrl;
    },
    onPreviousClick: function (_event) {
      location.href = this.previousUrl;
    },
    onClipClick: function(event) {
      event.preventDefault();
      this.$copyText(this.scriptTag).then(function (_e) {
      }, function (_e) {
      })
    },
    onServiceWorkerClick: function(event) {
      event.preventDefault();
      location.href = '/coins-admin/onboarding/download?filename=serviceworker.js';
    },
    onManifestClick: function(event) {
      event.preventDefault();
      location.href = '/coins-admin/onboarding/download?filename=manifest.json';
    },
    onScriptTagSettingChange() {
      const parser = new DOMParser();
      const scriptDocument = parser.parseFromString(this.tag, 'text/html');
      const scriptTag = scriptDocument.querySelector('script');
      if (this.isPreoptinChecked !== 0) {
        scriptTag.setAttribute('data-optindialog', 'on');
      }
      if (this.isPreoptinChecked === 2) {
        scriptTag.setAttribute('data-requiredbrowser', 'on');
      }
      if (this.isIosChecked) {
        scriptTag.setAttribute('data-iosdialog', 'on');
      }
      if (this.isBlockChecked) {
        scriptTag.setAttribute('data-unblockingrequest', 'on');
      }

      this.scriptTag =
        `<!--  <BODY></BODY>タグ内の最下位に記述をオススメします ここから-->
${scriptTag.outerHTML}
<!-- ここまで -->`;

      const data = {
        ios: this.isIosChecked,
        preoptin: this.isPreoptinChecked,
        block: this.isBlockChecked,
      }
      axios.post('/api/script-tag-setting/save', data)
        .then(_res => {})
        .catch(_e => {});
    },
    toggleCopyText: function () {
      this.isCopied = true;
      setTimeout(() => {
        this.isCopied = false;
      }, 2000);
    },
  },
}
</script>
